import React, { useState } from 'react'
import { LearningItem, OnDemandCourse, ScheduledCourse } from '../../models/LearningItem'
import styles from './CourseLearningPathPage.module.scss'
import { Link } from 'react-router-dom'
import LearningItemImage from '../../components/LearningItemImage/LearningItemImage'
import useRoutes from '../../state/useRoutes'
import { useTranslation } from 'react-i18next'
import ChevronRight from '@material-symbols/svg-300/outlined/chevron_right.svg'
import { CoursePageScheduledCourseEventsList } from '../CoursePage/CoursePageScheduledCourse'
import Markdown from 'react-markdown'
import { OnDemandCourseQuickFacts } from '../CoursePage/CoursePage'

/**
 * Tip:
 * All the subcomponents to the CourseLearningPathLearningItem are not memoized
 * because they share the same arguments as the parent.
 */
export default React.memo(function CourseLearningPathLearningItem({ learningItem }: { learningItem: LearningItem }) {
  const [isDetailsVisible, setDetailsVisible] = useState(false)
  const routes = useRoutes()

  const toggleDetails = () => {
    setDetailsVisible(!isDetailsVisible)
  }

  return (
    <>
      <div className={styles.CourseLearningPathLearningItem}>
        <div>
          <span onClick={toggleDetails} className={styles.detailsArrow}>
            <ChevronRight className={isDetailsVisible ? styles.open : ''} />
          </span>
          <span>
            <Link to={routes.course.url({ uuid: learningItem.uuid })}>
              <LearningItemImage learningItem={learningItem} className={styles.coverListImage} />
            </Link>
          </span>
          <span>
            {learningItem.kind === 'scheduledCourse' && <ScheduledCourseDatesColumn learningItem={learningItem} />}
            {learningItem.kind === 'onDemandCourse' && <OnDemandCourseDatesColumn />}
          </span>
          <span>{learningItem.title}</span>
          <span>{learningItem.kind === 'scheduledCourse' && <ScheduledCourseAttendeeColumn />}</span>
        </div>

        <div className={isDetailsVisible ? `${styles.details} ${styles.open}` : styles.details}>
          {learningItem.kind === 'scheduledCourse' && <ScheduledCourseDetails learningItem={learningItem} />}
          {learningItem.kind === 'onDemandCourse' && <OnDemandCourseDetails learningItem={learningItem} />}
        </div>
      </div>
    </>
  )
})

function ScheduledCourseDatesColumn({ learningItem }: { learningItem: ScheduledCourse }) {
  const { t } = useTranslation()

  return <>{t('learning path.{count} events', { count: learningItem.scheduledCourse.events.length })}</>
}

function OnDemandCourseDatesColumn() {
  const { t } = useTranslation()

  return <>{t('learning path.on demand')}</>
}

// function ScheduledCourseAttendeeColumn( {learningItem}: { learningItem: ScheduledCourse } ) {
function ScheduledCourseAttendeeColumn() {
  return <></>
}

function ScheduledCourseDetails({ learningItem }: { learningItem: ScheduledCourse }) {
  return (
    <div>
      <CoursePageScheduledCourseEventsList scheduledCourse={learningItem} fromPath={true} />
    </div>
  )
}

function OnDemandCourseDetails({ learningItem }: { learningItem: OnDemandCourse }) {
  return (
    <section className={styles.learningItemCourseDescription}>
      <div className={styles.belowImage}>
        <OnDemandCourseQuickFacts course={learningItem} />

        <div className={styles.descriptionText}>
          <Markdown>{learningItem.description}</Markdown>
        </div>
      </div>
    </section>
  )
}
